export default __webpack_public_path__ + "static/media/easter_island.fd20b953.svg";